module.exports = __webpack_public_path__ + "img/国风新材.1cde8002.png";